import * as api from "../api/index";

export const RateCardService = {
  createRateCard,
  updateRateCard,
  getRateCardList,
  getRateCardListWithoutPagination,
  getRateCardDetilsById,

  createDigitalRateCard,
  updateDigitalRateCard,
  getDigitalRateCardList,
  getDigitalRateCardListWithoutPagination,
  getDigitalRateCardDetilsById
};

async function createRateCard(formData) {
  try {
    const { data } = await api.createRateCard(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateRateCard(formData) {
  try {
    const { data } = await api.updateRateCard(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getRateCardList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getRateCardList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getRateCardDetilsById(formData) {
  try {
    const { data } = await api.getRateCardDetilsById(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getRateCardListWithoutPagination() {
  try {
    const { data } = await api.getRateCardListWithoutPagination();
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createDigitalRateCard(formData) {
  try {
    const { data } = await api.createDigitalRateCard(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updateDigitalRateCard(formData) {
  try {
    const { data } = await api.updateDigitalRateCard(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getDigitalRateCardList(formData, page, rowsPerPage) {
  try {
    const { data } = await api.getDigitalRateCardList(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getDigitalRateCardDetilsById(formData) {
  try {
    const { data } = await api.getDigitalRateCardDetilsById(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getDigitalRateCardListWithoutPagination() {
  try {
    const { data } = await api.getDigitalRateCardListWithoutPagination();
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}